import jwtDecode, { JwtPayload } from 'jwt-decode'

const DEFAULT_LEEWAY = 60

// We don't verify the token, we just decode and check certain fields
export const isInsecurelyValidJWT = (
  jwt: string,
  leeway = DEFAULT_LEEWAY
): boolean => {
  try {
    const decoded = jwtDecode<JwtPayload>(jwt)
    const now = new Date(Date.now())

    if (hasExpired(decoded, leeway, now) || hasNotBegun(decoded, leeway, now)) {
      return false
    } else {
      return true
    }
  } catch (e) {
    // jwtDecode just throws an exception if a token is malformed
    return false
  }
}

export const hasExpired = (
  payload: JwtPayload,
  leeway: number,
  now: Date
): boolean => {
  const expDate = new Date(0)
  if (payload.exp) {
    expDate.setUTCSeconds(payload.exp + leeway)
    return now > expDate
  } else {
    // We don't accept tokens without an Expiry time
    return true
  }
}

export const hasNotBegun = (
  payload: JwtPayload,
  leeway: number,
  now: Date
): boolean => {
  const nbfDate = new Date(0)
  if (payload.nbf) {
    nbfDate.setUTCSeconds(payload.nbf - leeway)
    return now < nbfDate
  } else {
    // Nbf is optional
    return false
  }
}
